import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormikButtonGroup } from '../../../components/FormikButtonGroup/FormikButtonGroup';
import { QuestionItem } from '../../types/QuestionItem';

export const MilesPerYear: React.FC = () => {
  const { t } = useTranslation('match-maker');

  const mileageOptions: QuestionItem<number>[] = [
    {
      displayName: t('question-pages.items.mileage.options.one'),
      value: 10000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear10.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.two'),
      value: 15000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear15.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.three'),
      value: 20000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear20.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.four'),
      value: 25000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear25.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.five'),
      value: 30000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear30.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.six'),
      value: 35000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear35.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.seven'),
      value: 40000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear40.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.eight'),
      value: 45000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear45.000'
    },
    {
      displayName: t('question-pages.items.mileage.options.nine'),
      value: 50000,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonMilesPerYear50.000'
    }
  ];

  return (
    <FormikButtonGroup
      itemList={mileageOptions}
      inputType="radio"
      propName="milesPerYear"
      auto={true}
      small={true}
      fieldValueType="scalar"
      data-testid="formikButtonGroup-milesPerYear"
    />
  );
};
